import React from 'react';
import { DoshiiItemVariantAvailabilityChangeProps } from 'types';
import Button from 'components/Button/Button';

import IconQuestion from 'icons/ic_ErrorQuestion.svg';
import { AmplitudeEventCategories, logAmplitudeEvent } from 'utils/Amplitude';

interface ComponentProps {
  styles: {
    [key: string]: string;
  };
  closeModal: () => void;
}

const DoshiiItemVariantAvailabilityChange: React.FC<DoshiiItemVariantAvailabilityChangeProps & ComponentProps> = ({
  callback,
  styles,
  closeModal
}) => {
  const logInAmplitude = (action: 'confirm' | 'cancel'): void => {
    logAmplitudeEvent({
      name: `item and doshii:item confirmation dialog (${action})`,
      category: AmplitudeEventCategories.MM_ALL_ITEMS
    });
  };

  return (
    <div
      data-testid="item-and-item-as-options-availability-change-confirm"
      role="dialog"
      aria-labelledby="item-and-item-as-options-availability-change-title"
      aria-describedby="item-and-item-as-options-availability-change-description"
    >
      <img src={IconQuestion} alt="" />
      <h2 id="item-and-item-as-options-availability-change-title">Change availability?</h2>
      <p id="item-and-item-as-options-availability-change-description" data-testid="availability-change-confirm-copy">
        Changing availability of this item will change the availability of all item options where this item is used.
      </p>
      <div className={styles.ButtonRow}>
        <Button
          onClick={() => {
            logInAmplitude('cancel');
            closeModal();
          }}
          level="low"
        >
          <span>Cancel</span>
        </Button>
        <Button
          onClick={() => {
            logInAmplitude('confirm');
            callback();
            closeModal();
          }}
        >
          <span>Ok, got it</span>
        </Button>
      </div>
    </div>
  );
};

export default DoshiiItemVariantAvailabilityChange;
